// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_container__gAL5r","carousel":"Carousel_carousel__N_M0I","item":"Carousel_item__Mktf8","badge":"Carousel_badge___2LHH","title":"Carousel_title__vEdcr"};